import Vue from 'vue'
// import $ from 'webpack-zepto'
/**
 * 通用alert弹窗样式
 */
export default {
  install () {
    Vue.prototype.$isDefine = (value) => {
      if (value == null || value == '' || value == 'undefined' || value == undefined || value == 'null' || value == '(null)' || value == 'NULL' || typeof (value) === 'undefined') {
        return false
      }
      return true
    }
  }
}



// WEBPACK FOOTER //
// ./src/config/isDefine.js